import {gql} from '@apollo/client';
import {PopReviewAction, PopReviewActionResult} from '../types/PopReviewType';

/**
 * 提交 POP 审核（一次一单，批量由前端逐条调用）
 * 审核员由后端取当前登录账号，前端不传 —— 防止伪造审核人。
 */
export const SUBMIT_POP_REVIEW_ACTION = gql`
    mutation SubmitPopReviewAction(
        $reviewTaskId: String!
        $action: PopReviewActionType!
        $disqualifyReasonCodes: [String!]
        $reviewRemark: String
        $reviewRemarkLang: String
    ) {
        submitPopReviewAction(
            reviewTaskId: $reviewTaskId
            action: $action
            disqualifyReasonCodes: $disqualifyReasonCodes
            reviewRemark: $reviewRemark
            reviewRemarkLang: $reviewRemarkLang
        ) {
            reviewTaskId
            appointmentId
            appointmentNumber
            status
            reviewerId
            reviewedAt
        }
    }
`;

export interface SubmitPopReviewActionResponse {
    submitPopReviewAction: PopReviewActionResult;
}

export interface SubmitPopReviewActionInput {
    reviewTaskId: string;
    action: PopReviewAction;
    /** 判定「疑似虚假」时必填 */
    disqualifyReasonCodes?: string[];
    reviewRemark?: string;
    /** 备注原文语种（前端当前 locale）；后端据此填充富化 JSON 的 lang */
    reviewRemarkLang?: string;
}
